import * as React from "react";
import {backend} from "../../../../../xconvert-backend";
import {authentication} from "../../../../../authentication";
import {useEffect, useState} from "react";
import {Icon, Loader, Table} from "semantic-ui-react";
import {formatHealthReportDate} from "../../../../../format";

export interface RecentDeployment {
    projectName: string;
    environment: string;
    jobName: string;
    pipelineId: number;
    webUrl: string | null;
    pipelineCreatedAt: string | number | null;
    deployedAt: string | number | null;
    source: string | null;
    triggeredBy: string | null;
}

export function RecentDeployments() {
    const [deployments, setDeployments] = useState<RecentDeployment[]>([]);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        callRecentDeployments();
    }, []);

    async function callRecentDeployments() {
        const auth = backend.withTokenAuthHeader(authentication.token);
        try {
            const response = await fetch("/internalMonitoring/getRecentDeployments?limit=10", {
                method: "GET",
                headers: {
                    Authorization: auth.headers.Authorization.toString(),
                    "Content-Type": "application/json; charset=utf-8"
                }
            });

            if (response.ok) {
                setDeployments(await response.json());
            }
        } catch {
        } finally {
            setLoading(false);
        }
    }

    if (isLoading) {
        return (
            <div style={{marginTop: "1.5em", marginBottom: "1em"}}>
                <Loader active inline="centered" size="small">
                    Loading recent deployments
                </Loader>
            </div>
        );
    }

    return (
        <div style={{marginTop: "1.5em", marginBottom: "1.5em"}}>
            <h4>
                <Icon name="rocket"/> Latest Deployments
            </h4>
            <Table compact size="small">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Service</Table.HeaderCell>
                        <Table.HeaderCell>Environment</Table.HeaderCell>
                        <Table.HeaderCell>Job</Table.HeaderCell>
                        <Table.HeaderCell>Pipeline</Table.HeaderCell>
                        <Table.HeaderCell>Pipeline created</Table.HeaderCell>
                        <Table.HeaderCell>Deployed at</Table.HeaderCell>
                        <Table.HeaderCell>Source</Table.HeaderCell>
                        <Table.HeaderCell>Triggered by</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {deployments.length === 0 ? (
                        <Table.Row>
                            <Table.Cell colSpan={8} style={{textAlign: "center", color: "#999"}}>
                                No recent deployments (recorded when deploy jobs run for non‑alpha environments)
                            </Table.Cell>
                        </Table.Row>
                    ) : deployments.map((d, i) => (
                        <Table.Row key={`${d.pipelineId}-${d.jobName}-${d.deployedAt}-${i}`}>
                            <Table.Cell>{d.projectName ?? "-"}</Table.Cell>
                            <Table.Cell>{d.environment ?? "-"}</Table.Cell>
                            <Table.Cell>{d.jobName ?? "-"}</Table.Cell>
                            <Table.Cell>
                                {d.webUrl ? (
                                    <a href={d.webUrl} target="_blank" rel="noopener noreferrer">
                                        #{d.pipelineId}
                                    </a>
                                ) : (
                                    `#${d.pipelineId}`
                                )}
                            </Table.Cell>
                            <Table.Cell>{formatHealthReportDate(d.pipelineCreatedAt) || "—"}</Table.Cell>
                            <Table.Cell>{formatHealthReportDate(d.deployedAt) || "—"}</Table.Cell>
                            <Table.Cell>{d.source ?? "-"}</Table.Cell>
                            <Table.Cell>{d.triggeredBy ?? "-"}</Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </div>
    );
}
